/**
价格管理反算工具类
ver 1.0.0
修改记录：
  2018-10-22：
    priceControlBackCountUtil.
*/
import calculateUtils from '../calculateUtil'
import objectUtil from '../objectUtil'
let priceControlBackCountUtil = {}

/**
 * 参与计算对应字段
 * @数量 {[amount]}
 * @报价 {[pricing]}
 * @折扣率 {[discount]}
 * @含税单价 {[price]}
 * @无税单价 {[netPrice]}
 * @无税金额 {[netMoney]}
 * @税额 {[netTax]}
 * @折扣额 {[discountTotal]}
 * @价税合计 {[priceTotal]}
 * @税率  {[rate]}
 * @是否赠品  {[attrs.valueText.discount]}
 * @含税报价总金额  {[pricingTotal]}
 * @采购含税单价  {[purchaseItem.price]}
 * @采购含税金额  {[purchaseItem.priceTotal]}
 *
 *   (页面暂无此字段)pricingTotal = 精确到分(amount * pricing)
 *
 * @折扣金额总计  {[discountsTotal]}
 * @折让金额  {[discountsDiffTotal]}
 * @促销折扣相关（促销折扣、促销折扣率、促销折扣额）  {[saleDownDiscount]}
 * @招标折扣相关（招标折扣、招标折扣率、招标折扣额）  {[publicDiscount]}
 * @销售折扣相关（销售折扣、销售折扣率、销售折扣额）  {[saleDiscount]}
 * @其他折扣1相关（其他折扣1、其他折扣率1、其他折扣额1）  {[otherDiscount1]}
 * @其他折扣1相关（其他折扣2、其他折扣率2、其他折扣额2）  {[otherDiscount2]}
 * @其他折扣1相关（其他折扣3、其他折扣率3、其他折扣额3）  {[otherDiscount3]}
 *  六个折扣相关的结构为下面所示    {
    	  discount: 2.21, // 折扣（单个）
      	discount: 2.21, // 折扣（单个）
      	discountTotal: 22.1, // 折扣额
      	discountTotal: 22.1, // 折扣额
      	discountRate: 0.1, // 折扣率
      	discountRate: 0.1 // 折扣率
       }
 */

/**
 * [在价格管理中录入、修改报价]
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} fildKey    [哪一类折扣]
 * @param  {[type]} decimal [保留小数多少位]
  含税单价=报价-折扣1到6之和
 */
priceControlBackCountUtil.pricing = function (data, formData, decimal = 6) {
  priceControlBackCountUtil.initDiscounts(data)
  data.price = calculateUtils.numberSub(
    data.pricing,
    priceControlBackCountUtil.discountsFn(data),
    decimal
  )
  data.discounts.saleDownDiscount.discountRate = calculateUtils.numberSub(
    1,
    calculateUtils.numberDiv(data.discounts.saleDownDiscount.discount, data.pricing, decimal),
    decimal
  )
  data.discounts.publicDiscount.discountRate = calculateUtils.numberSub(
    1,
    calculateUtils.numberDiv(data.discounts.publicDiscount.discount, data.pricing, decimal),
    decimal
  )
  data.discounts.saleDiscount.discountRate = calculateUtils.numberSub(
    1,
    calculateUtils.numberDiv(data.discounts.saleDiscount.discount, data.pricing, decimal),
    decimal
  )
  data.discounts.otherDiscount1.discountRate = calculateUtils.numberSub(
    1,
    calculateUtils.numberDiv(data.discounts.otherDiscount1.discount, data.pricing, decimal),
    decimal
  )
  data.discounts.otherDiscount2.discountRate = calculateUtils.numberSub(
    1,
    calculateUtils.numberDiv(data.discounts.otherDiscount2.discount, data.pricing, decimal),
    decimal
  )
}

// * @促销折扣相关（促销折扣、促销折扣率、促销折扣额）  {[saleDownDiscount]}
//  * @招标折扣相关（招标折扣、招标折扣率、招标折扣额）  {[publicDiscount]}
//  * @销售折扣相关（销售折扣、销售折扣率、销售折扣额）  {[saleDiscount]}
//  * @其他折扣1相关（其他折扣1、其他折扣率1、其他折扣额1）  {[otherDiscount1]}
//  * @其他折扣1相关（其他折扣2、其他折扣率2、其他折扣额2）  {[otherDiscount2]}

/**
 * [录入、修改折扣1到6]
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} fildKey    [哪一类折扣]
 * @param  {[type]} hideTotal    [是否隐藏折扣额]
 * @param  {[type]} decimal [保留小数多少位]
 */
priceControlBackCountUtil.discount = function (data, formData, fildKey, decimal = 6) {
  priceControlBackCountUtil.initDiscounts(data)
  data.price = calculateUtils.numberSub(
    data.pricing,
    priceControlBackCountUtil.discountsFn(data),
    decimal
  )
  data.discounts[fildKey].discountRate = calculateUtils.numberSub(
    1,
    calculateUtils.numberDiv(data.discounts[fildKey].discount, data.pricing, decimal),
    decimal
  )
}

/**
 * [录入、修改折扣率1到6]
 * @param  {[type]} data    [行数据data]
 * @param  {[type]} formData    [整单数据]
 * @param  {[type]} fildKey    [哪一类折扣]
 * @param  {[type]} hideTotal    [是否隐藏折扣额]
 * @param  {[type]} decimal [保留小数多少位]
 *
 */
priceControlBackCountUtil.discountRate = function (data, formData, fildKey, decimal = 6) {
  priceControlBackCountUtil.initDiscounts(data)
  data.discounts[fildKey].discount = calculateUtils.numberMul(
    data.pricing,
    calculateUtils.numberSub(1, data.discounts[fildKey].discountRate),
    decimal
  )
  data.price = calculateUtils.numberSub(
    data.pricing,
    priceControlBackCountUtil.discountsFn(data),
    decimal
  )
}

//初始化六组折扣字段
priceControlBackCountUtil.initDiscounts = function (data) {
  let discountKey = 'discounts'
  if (!data[discountKey]) data[discountKey] = {}
  if (!data[discountKey].saleDownDiscount) data[discountKey].saleDownDiscount = {}

  if (!data[discountKey].publicDiscount) data[discountKey].publicDiscount = {}

  if (!data[discountKey].saleDiscount) data[discountKey].saleDiscount = {}

  if (!data[discountKey].otherDiscount1) data[discountKey].otherDiscount1 = {}

  if (!data[discountKey].otherDiscount2) data[discountKey].otherDiscount2 = {}

  if (!data[discountKey].otherDiscount3) data[discountKey].otherDiscount3 = {}
}

//计算折扣1-6之和
priceControlBackCountUtil.discountsFn = function (data, decimal = 6) {
  let discountKey = 'discounts'
  let temp1 = calculateUtils.numberAdd(
    data[discountKey].saleDownDiscount.discount,
    data[discountKey].publicDiscount.discount,
    decimal
  )
  let temp2 = calculateUtils.numberAdd(temp1, data[discountKey].saleDiscount.discount, decimal)
  let temp3 = calculateUtils.numberAdd(temp2, data[discountKey].otherDiscount1.discount, decimal)
  let temp4 = calculateUtils.numberAdd(temp3, data[discountKey].otherDiscount2.discount, decimal)
  let temp5 = calculateUtils.numberAdd(temp4, data[discountKey].otherDiscount3.discount, decimal)
  return temp5
}

export default priceControlBackCountUtil
